export const concatName = (...nameParts) => {
  return nameParts
    .filter(Boolean)
    .join(" ")
    .trim();
};

export const concatNameFromSignatory = signatory => {
  return concatName(signatory?.firstName, signatory?.middleName, signatory?.lastName);
};
